import React from "react";
import { Carousel3D } from "./Carousel3D";
import { getEcosystemModules } from "./ecosystemModules";

export function EcosystemPanel({ t, language }) {
  const modules = getEcosystemModules(language);

  return (
    <div className="eco-panel">
      <span className="eco-panel__star eco-panel__star--1" />
      <span className="eco-panel__star eco-panel__star--2" />
      <span className="eco-panel__star eco-panel__star--3" />

      <div className="eco-panel__header">
        <div>
          <div className="eco-panel__kicker">{t("eco_kicker")}</div>
          <h2 className="eco-panel__heading">
            {t("eco_heading_pre")}
            <span className="eco-panel__heading-highlight">
              {t("eco_heading_highlight")}
            </span>
          </h2>
        </div>
        <span className="eco-panel__count">{t("eco_modules_count")}</span>
      </div>

      <div className="eco-panel__body">
        <div className="eco-panel__kpis">
          <div className="eco-panel__kpi">
            <span className="eco-panel__kpi-label">
              <span className="eco-panel__kpi-dot" style={{ background: "#C3E2F7" }} />
              {t("eco_kpi_legal")}
            </span>
            <div className="eco-panel__kpi-value">87%</div>
          </div>
          <div className="eco-panel__kpi-divider" />
          <div className="eco-panel__kpi">
            <span className="eco-panel__kpi-label">
              <span className="eco-panel__kpi-dot" style={{ background: "#578EBF" }} />
              {t("eco_kpi_gei")}
            </span>
            <div className="eco-panel__kpi-value">
              1.240<span className="eco-panel__kpi-unit"> tCO₂e</span>
            </div>
          </div>
          <div className="eco-panel__kpi-divider" />
          <div className="eco-panel__kpi">
            <span className="eco-panel__kpi-label">
              <span className="eco-panel__kpi-dot" style={{ background: "#fff" }} />
              {t("eco_kpi_plan")}
            </span>
            <div className="eco-panel__kpi-value">68%</div>
          </div>
        </div>

        <div className="eco-panel__carousel-wrap">
          <div className="eco-panel__carousel-tilt">
            <Carousel3D
              axis="X"
              modules={modules}
              cardWidth={250}
              cardHeight={140}
              translateZ={275}
              duration={36}
            />
          </div>
        </div>
      </div>

      <div className="eco-panel__footer">
        <span>{t("eco_footer_pillars")}</span>
        <span className="eco-panel__footer-brand">{t("eco_footer_brand")}</span>
      </div>
    </div>
  );
}
